import { useQuery } from '@tanstack/react-query';

import axiosInstance from './axios';
import { getConfig } from './config';
import { APIResponse, User } from './types';

export const getUser = async () => {
  const config = getConfig();

  const response = await axiosInstance.get<APIResponse<User>>(`${config.domains.auth}/auth/user`);

  if (response.data.status === 'UNAUTHORIZED') {
    return null;
  }

  return response.data.data;
};
export const useGetUserQuery = () => {
  return useQuery({ queryKey: ['user'], queryFn: getUser, staleTime: Infinity });
};
